import React, { useMemo } from 'react';
import {
  useRegionCurrency,
  useProductService,
  useReviewService,
  ProductStockStatus,
  createReviewStatsMap,
  getLowestPriceProductBasicInfo,
} from '@skin-seoul/service';
import { GridItem } from '@skin-seoul/design-system';
import SkinSeoulHiddenGems from './components/SkinSeoulHiddenGems';
import { VerticalProductCard } from '../../components/ProductCard';

const HiddenGemProductList = () => {
  const { useGetProductsCollections } = useProductService();
  const { useGetReviewStatistics } = useReviewService();
  const { currency } = useRegionCurrency();

  const { data } = useGetProductsCollections({
    collectionName: 'GGU Hidden Gems',
    limit: 50,
    stockStatus: ProductStockStatus.instock,
    currency: currency,
  });

  const products = useMemo(() => {
    return (data?.products?.length ? data.products : []).slice(0, 5);
  }, [data]);

  const { data: reviewStats } = useGetReviewStatistics({
    productIds: products.map((product) => product.productId).join(','),
  });

  const reviewStatsMap = useMemo(() => createReviewStatsMap(reviewStats?.statistics), [reviewStats]);

  return (
    <React.Fragment>
      {products.map((product) => {
        const productInfo = getLowestPriceProductBasicInfo(product);
        const productReviewStats = reviewStatsMap[product.productId];

        return (
          <GridItem key={product.productId + 'hidden-gem-product-list'}>
            <VerticalProductCard
              name={productInfo.name}
              brand={productInfo.brand}
              productImage={productInfo.productImageUrls[0] || ''}
              sku={productInfo.sku}
              currency={productInfo.currency}
              originalPrice={productInfo.originalPrice}
              salePrice={productInfo.salePrice}
              rating={productReviewStats?.averageRate}
              reviewCount={productReviewStats?.totalReviews}
              onClick={() => (window.location.href = product.productLink)}
              theme="light"
            >
              <VerticalProductCard.Image
                topSlot={<VerticalProductCard.DiscountBadge />}
                bottomSlot={<SkinSeoulHiddenGems />}
              />
              <VerticalProductCard.Content>
                <VerticalProductCard.InfoName />
                <VerticalProductCard.InfoRating />
                <VerticalProductCard.InfoPrice />
              </VerticalProductCard.Content>
            </VerticalProductCard>
          </GridItem>
        );
      })}
    </React.Fragment>
  );
};

export default HiddenGemProductList;
